// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"041889ee","453":"78dd2e9e","745":"43434de3"}[chunkId] + ".chunk.js";
};